(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-podcast"] && !Shopify.designMode) return;
  try {
    
function initializeAutoPodcasts(scope) {
  scope.querySelectorAll('[data-auto-podcast]').forEach(function(section) {
    if (section.dataset.feedReady) return;
    section.dataset.feedReady = 'true';
    const audio = section.querySelector('audio');
    const title = section.querySelector('h2');
    const status = section.querySelector('.mt-podcast__status');
    const fallback = section.querySelector('.mt-podcast__fallback');
    let currentUrl = '';
    let lastChecked = 0;
    let busy = false;
    let pending = null;
    function applyEpisode(episode) {
      if (episode.url !== currentUrl) {
        currentUrl = episode.url;
        audio.src = episode.url;
        audio.load();
      }
      title.textContent = episode.title;
      audio.setAttribute('aria-label', episode.title);
      audio.hidden = false;
      fallback.hidden = true;
      status.textContent = '';
    }
    async function refresh() {
      if (busy || !section.isConnected || document.hidden) return;
      busy = true;
      const controller = new AbortController();
      const timeout = setTimeout(function() { controller.abort(); }, 12000);
      try {
        const response = await fetch(section.dataset.feedUrl, {cache:'no-store', signal:controller.signal, credentials:'omit'});
        if (!response.ok) throw new Error('Feed unavailable');
        const xml = new DOMParser().parseFromString(await response.text(), 'application/xml');
        if (xml.querySelector('parsererror')) throw new Error('Invalid feed');
        const episodes = Array.from(xml.querySelectorAll('channel > item')).map(function(item) {
          const enclosure = item.querySelector('enclosure');
          const url = enclosure ? enclosure.getAttribute('url') : '';
          return {title:item.querySelector('title')?.textContent?.trim() || '', url:url, date:Date.parse(item.querySelector('pubDate')?.textContent || '') || 0, type:enclosure?.getAttribute('type') || ''};
        }).filter(function(item) {
          try { return item.title && new URL(item.url).protocol === 'https:' && (!item.type || item.type.startsWith('audio/')); } catch (_) { return false; }
        }).sort(function(a,b) { return b.date-a.date; });
        if (!episodes.length) throw new Error('No episodes');
        const episode = episodes[0];
        if (!audio.paused && episode.url !== currentUrl) pending = episode;
        else applyEpisode(episode);
        lastChecked = Date.now();
      } catch (_) {
        status.textContent = section.dataset.unavailableLabel;
        fallback.hidden = false;
        if (audio.paused) {
          audio.hidden = true;
          audio.removeAttribute('src');
          audio.load();
          currentUrl = '';
        }
      } finally {
        clearTimeout(timeout);
        busy = false;
      }
    }
    audio.addEventListener('pause', function() { if (pending) { applyEpisode(pending); pending = null; } });
    function onVisible() { if (!document.hidden && Date.now()-lastChecked > 60000) refresh(); }
    document.addEventListener('visibilitychange', onVisible);
    const timer = setInterval(function() {
      if (!section.isConnected) { clearInterval(timer); document.removeEventListener('visibilitychange',onVisible); return; }
      refresh();
    }, 300000);
    refresh();
  });
}
initializeAutoPodcasts(document);
document.addEventListener('shopify:section:load', function(event) { initializeAutoPodcasts(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-reviews"] && !Shopify.designMode) return;
  try {
    
function initReviews(root){root.querySelectorAll('[data-review-carousel]').forEach(function(el){if(el.dataset.ready)return;el.dataset.ready='true';const track=el.querySelector('.mt-reviews__track'),cards=Array.from(track.children),buttons=el.querySelectorAll('button');function index(){return cards.reduce(function(best,card,i){return Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-track.scrollLeft)?i:best;},0);}function update(){const i=index();buttons[0].disabled=i===0;buttons[1].disabled=i===cards.length-1;el.querySelector('[data-count]').textContent=(i+1)+' / '+cards.length;}buttons.forEach(function(b){b.addEventListener('click',function(){const i=Math.max(0,Math.min(cards.length-1,index()+Number(b.dataset.direction)));track.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});});track.addEventListener('scroll',update,{passive:true});update();});}
initReviews(document);document.addEventListener('shopify:section:load',function(e){initReviews(e.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-youtube"] && !Shopify.designMode) return;
  try {
    
  function initializeMichelleWatch(scope) {
    scope.querySelectorAll('.mt-watch:not([data-ready])').forEach(function(section) {
      section.dataset.ready = 'true';
      const track = section.querySelector('.mt-watch__track');
      const cards = Array.from(track.querySelectorAll('.mt-watch__card'));
      const arrows = Array.from(section.querySelectorAll('[data-mt-direction]'));
      const reset = function(card) {
        const frame = card.querySelector('iframe');
        const link = card.querySelector('.mt-watch__play');
        if (frame) frame.remove();
        if (link) link.hidden = false;
      };
      const currentIndex = function() {
        let index = 0;
        let distance = Infinity;
        const left = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
        cards.forEach(function(card, i) {
          const delta = Math.abs(card.getBoundingClientRect().left - left);
          if (delta < distance) { index = i; distance = delta; }
        });
        return index;
      };
      const update = function() {
        const index = currentIndex();
        arrows.forEach(function(button) {
          button.disabled = Number(button.dataset.mtDirection) < 0 ? index === 0 : index === cards.length - 1;
        });
      };
      arrows.forEach(function(button) {
        button.addEventListener('click', function() {
          const index = Math.max(0, Math.min(cards.length - 1, currentIndex() + Number(button.dataset.mtDirection)));
          cards.forEach(reset);
          const card = cards[index];
          const padding = parseFloat(getComputedStyle(track).paddingLeft);
          track.scrollTo({left: track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - padding, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        });
      });
      track.addEventListener('scroll', update, {passive: true});
      section.querySelectorAll('[data-mt-video]').forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          cards.forEach(reset);
          document.querySelectorAll('.mt-podcast audio').forEach(function(audio) { audio.pause(); });
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(link.dataset.mtVideo) + '?autoplay=1&rel=0';
          frame.title = link.getAttribute('aria-label');
          frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          link.hidden = true;
          link.parentElement.appendChild(frame);
          frame.focus();
        });
      });
      document.addEventListener('play', function(event) {
        if (event.target instanceof HTMLAudioElement && event.target.closest('.mt-podcast')) cards.forEach(reset);
      }, true);
      update();
    });
  }
  initializeMichelleWatch(document);
  document.addEventListener('shopify:section:load', function(event) { initializeMichelleWatch(event.target.parentElement || document); });

  } catch(e) { console.error(e); }
})();
})();
